import { Grid } from '@mui/material';
import { VideoItem } from './utils';

interface VideoLink {
  title: string;
  description: string;
  video: string;
}

interface VideoGridProps {
  videoLinks: VideoLink[];
}

export const VideoGrid = ({ videoLinks }: VideoGridProps) => {
  return (
    <Grid container sx={{ mb: 4, gridAutoFlow: 'column' }}>
      {videoLinks.map((video) => (
        <VideoItem
          key={video.title}
          title={video.title}
          description={video.description}
          video={video.video}
        />
      ))}
    </Grid>
  );
};

export default VideoGrid;